import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { MegaMenuItem } from '../../data/navigation';
import { formatPrice } from '../../utils/currency';
import { getProduct, pricePerKwh } from '../../utils/products';
export function MegaMenuPanel({
  item,
  onNavigate
}: {
  item: MegaMenuItem;
  onNavigate: () => void;
}) {
  const featured = getProduct(item.featuredId);
  const perKwh = featured ? pricePerKwh(featured) : null;
  return <div className="mx-auto grid max-w-7xl grid-cols-12 gap-10 px-8 py-8" data-id="element-323" data-mp="1x9tulsrn5el4">
      {item.groups.map((g, gi) => <div key={g.title} className={gi === 0 ? 'col-span-5' : 'col-span-3'} data-id="element-324" data-mp="1t7701k3l5fk8" data-mpi={gi}>
          <p className="text-xs font-semibold text-muted" data-id="element-325" data-mp="1o95hd0a2ni9a">{g.title}</p>
          <ul className={`mt-3 ${gi === 0 ? 'space-y-1' : 'space-y-2.5'}`} data-id="element-326" data-mp="1o6sr7zu5u1l5">
            {g.links.map(l => <li key={l.label} data-id="element-327" data-mp="1jbn5p24o6oxl">
                <Link to={l.href} onClick={onNavigate} className={gi === 0 ? 'group -mx-3 flex items-center justify-between rounded-lg px-3 py-2.5 hover:bg-surface' : 'text-sm text-ink hover:underline'} data-id="element-328" data-mp="1eafx50updlpv">
                  {gi === 0 ? <>
                      <span data-id="element-329" data-mp="3li482obc89uu">
                        <span className="block text-sm font-semibold text-ink" data-id="element-330" data-mp="3leqadtdmcotq">{l.label}</span>
                        {l.detail && <span className="block text-xs text-muted" data-id="element-331" data-mp="hzugq4f8svki">{l.detail}</span>}
                      </span>
                      <ArrowRightIcon className="h-4 w-4 text-muted transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-332" data-mp="mzgxuoy6yvyl" />
                    </> : l.label}
                </Link>
              </li>)}
          </ul>
          {gi === 0 && <Link to={item.href} onClick={onNavigate} className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-ink underline underline-offset-4" data-id="element-333" data-mp="2sqc9n5v5beeh">
              Alle {item.label.toLowerCase()}
            </Link>}
        </div>)}

      {featured && <Link to={`/product/${featured.id}`} onClick={onNavigate} className="group col-span-4 col-start-9 flex gap-4 rounded-2xl bg-surface p-4" data-id="element-334" data-mp="za7yufmtzivy">
          <img src={featured.image} alt="" className="h-28 w-28 shrink-0 rounded-xl bg-white object-cover" data-id="element-335" data-mp="pk53i8s8lsug" />
          <div className="flex min-w-0 flex-col" data-id="element-336" data-mp="klbogbxaxts6">
            <span className="w-fit rounded-md bg-ink px-2 py-0.5 text-[11px] font-bold text-volt" data-id="element-337" data-mp="khxpldnuk2ph">Keuze van Ampra</span>
            <span className="mt-2 text-sm font-semibold leading-snug text-ink group-hover:underline" data-id="element-338" data-mp="bjcbbuper9ui">{featured.name}</span>
            <span className="mt-auto pt-2 text-lg font-bold tracking-tight text-ink" data-id="element-339" data-mp="6lj4czga6bt6">
              <span className="mr-1 text-xs font-medium text-muted" data-id="element-340" data-mp="25xvb3pikez8u">vanaf</span>
              {formatPrice(featured.price)}
            </span>
            {perKwh && <span className="text-xs font-medium text-muted" data-id="element-341" data-mp="20wfnpqsx0gna">{formatPrice(perKwh)} per kWh</span>}
          </div>
        </Link>}
    </div>;
}